import * as ModalActions from '../actions/modal'
import * as PoolDeleteActions from '../actions/poolDelete'

const initialState = {
  isOpen: false,
  modalType: PoolDeleteActions.DELETE_POOL
}

export default (state = initialState, action) => {
  switch (action.type) {
  case ModalActions.SHOW_MODAL:
    return {
      isOpen: true,
      modalType: action.modalType
    }

  case ModalActions.HIDE_MODAL:
    return {
      ...state,
      isOpen: false,
    }

  default:
    return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/modal.js